import { LUXURY_PLUS_PATHS } from 'luxPlus/constants/base'
import { LOYALTY_PURCHASE_POINTS_SUCCESS_SESSION_KEY } from 'loyalty/constants/loyaltyPurchasePoints'

export function getCheckoutRouteFromURL(pathname: string): string {
  const split = pathname.split('/').pop() || ''
  return split?.split('?')[0]
}

export function getOnPurchaseSuccessPath(
  order: App.Order,
  isLuxPlusEnabled: boolean,
  orderItemId?: string,
  postPurchase?: string,
  isLoyaltyPurchasePoints?: boolean,
): string {
  const { itemsCount, id: orderId, subscriptionItems } = order
  const orderItemIdParam = orderItemId ? `&orderItemId=${orderItemId}` : ''
  let postPurchaseParam = ''

  if (postPurchase === 'change-dates' || postPurchase === 'change-package') {
    postPurchaseParam = `&postPurchase=${postPurchase}`
  }

  const DEFAULT_REDIRECT_PATH = `/booking/confirmation?orderId=${orderId}${orderItemIdParam}${postPurchaseParam}`
  const hasSubscriptionItems = subscriptionItems.length > 0

  if (isLoyaltyPurchasePoints) {
    try {
      sessionStorage.setItem(LOYALTY_PURCHASE_POINTS_SUCCESS_SESSION_KEY, '1')
    } catch {
      // sessionStorage may be unavailable (private browsing, quota, etc.)
    }
    return '/societe'
  }

  if (isLuxPlusEnabled && hasSubscriptionItems && itemsCount === subscriptionItems.length) {
    return `/${LUXURY_PLUS_PATHS.ACCOUNT_MANAGEMENT_PAGE}?orderId=${orderId}${orderItemIdParam}${postPurchaseParam}`
  }

  return DEFAULT_REDIRECT_PATH
}
